import { View } from 'backbone.marionette';
import Backbone from 'backbone';
import _ from 'lodash';

import OrderDeviceCollectionView from '../OrderDeviceCollectionView';
import OrderDeviceAdminCollectionView from '../OrderDeviceAdminCollectionView'

import tmplPRTNRDeviceSectionView from './PRTNRDeviceSectionView.hbs';

import './PRTNRDeviceSectionView.css';

const PRTNRDeviceSectionView = View.extend({
  template: tmplPRTNRDeviceSectionView,

  className: 'prtnr-device-section-view',

  ui: {
    vb1MonoCollection: '.vb1-mono-collection',
    vb1ColorCollection: '.vb1-color-collection',
    vb2MonoCollection: '.vb2-mono-collection',
    vb2ColorCollection: '.vb2-color-collection',
    vb3MonoCollection: '.vb3-mono-collection',
    vb3ColorCollection: '.vb3-color-collection',
    vb4MonoCollection: '.vb4-mono-collection',
    vb4ColorCollection: '.vb4-color-collection',
    vb5MonoCollection: '.vb5-mono-collection',
    vb5ColorCollection: '.vb5-color-collection',
    vb7MonoCollection: '.vb7-mono-collection',
    vb7ColorCollection: '.vb7-color-collection',
    vb8MonoCollection: '.vb8-mono-collection',
    vb8ColorCollection: '.vb8-color-collection',
    vb9MonoCollection: '.vb9-mono-collection',
    vb9ColorCollection: '.vb9-color-collection',
    servicesCollection: '.services-collection',
    toggle: '.toggle'
  },

  regions: {
    vb1MonoCollection: '@ui.vb1MonoCollection',
    vb1ColorCollection: '@ui.vb1ColorCollection',
    vb2MonoCollection: '@ui.vb2MonoCollection',
    vb2ColorCollection: '@ui.vb2ColorCollection',
    vb3MonoCollection: '@ui.vb3MonoCollection',
    vb3ColorCollection: '@ui.vb3ColorCollection',
    vb4MonoCollection: '@ui.vb4MonoCollection',
    vb4ColorCollection: '@ui.vb4ColorCollection',
    vb5MonoCollection: '@ui.vb5MonoCollection',
    vb5ColorCollection: '@ui.vb5ColorCollection',
    vb7MonoCollection: '@ui.vb7MonoCollection',
    vb7ColorCollection: '@ui.vb7ColorCollection',
    vb8MonoCollection: '@ui.vb8MonoCollection',
    vb8ColorCollection: '@ui.vb8ColorCollection',
    vb9MonoCollection: '@ui.vb9MonoCollection',
    vb9ColorCollection: '@ui.vb9ColorCollection',
    servicesCollection: '@ui.servicesCollection'
  },

  events: {
    'click @ui.toggle': 'onClickToggle'
  },

  collection: null,

  onClickToggle() {
    const id = this.model.get('id').concat('-caret');
    const caret = document.getElementById(id);
    if (caret.classList.contains('fa-caret-down')) {
      caret.classList.remove('fa-caret-down');
      caret.classList.add('fa-caret-up');
    } else if (caret.classList.contains('fa-caret-up')) {
      caret.classList.remove('fa-caret-up');
      caret.classList.add('fa-caret-down');
    }
  },

  onRender() {
    const lineItems = this.model.get('lineItems');

    this.collection = new Backbone.Collection([]);
    const collections = {
      vb1MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '25' })
      },
      vb1ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '25' })
      },
      vb2MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '35' })
      },
      vb2ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '35' })
      },
      vb3MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '45' })
      },
      vb3ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '45' })
      },
      vb4MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '50' })
      },
      vb4ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '50' })
      },
      vb5MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '60' })
      },
      vb5ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '60' })
      },
      vb7MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '90' })
      },
      vb7ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '80' })
      },
      vb8MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '110' })
      },
      vb8ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '95' })
      },
      vb9MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '130' })
      },
      vb9ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '115' })
      },
      servicesCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, (item) => {
          return item.panel === 'A3Services' || item.panel === 'A4Services' || item.panel === 'ProdServices';
        })
      }
    };

    _.each(Object.entries(collections), ([collectionName, collectionObj]) => {
      const { collection, items } = collectionObj;
      this.populateCollection(collection, items);
      if (collection.length > 0) {
        this.showChildCollection(collectionName, collection);
      }
    });
  },

  getDeviceData() {
    const changedItems = [];
    const lineItems = this.model.get('lineItems');
    let totalMonoQuantity = 0;
    let totalColorQuantity = 0;
    let totalMonthlyAdditionalServicesQuantity = 0;
    let totalYearlyOneTimeServicesQuantity = 0;

    _.each(this.collection.models, (model) => {
      const item = _.find(lineItems, { id: model.id });

      if (model.get('quantity') && model.get('quantity') !== '0') {
        switch (model.get('panel')) {
          case 'A3NIPR':
          case 'A3SIPR':
          case 'A4NIPR':
          case 'A4SIPR':
          case 'ProdNIPR':
          case 'ProdSIPR':
            if (model.get('isColor') === '1') {
              totalColorQuantity += parseInt(model.get('quantity'));
            } else if (model.get('isColor') === '0') {
              totalMonoQuantity += parseInt(model.get('quantity'));
            }
            break;
          case 'A3Services':
          case 'A4Services':
          case 'ProdServices':
            switch (model.get('chargesFrequencyId')) {
              case '1':
              case '3':
                totalYearlyOneTimeServicesQuantity += parseInt(model.get('quantity'));
                break;
              case '2':
                totalMonthlyAdditionalServicesQuantity += parseInt(model.get('quantity'));
                break;
            }
            break;
        }
      }
      if (model.get('quantity') !== item.quantity) {
        changedItems.push(model.attributes);
      }
    });
    const savedData = {
      changedItems,
      totalMonoQuantity,
      totalColorQuantity,
      totalMonthlyAdditionalServicesQuantity,
      totalYearlyOneTimeServicesQuantity
    };
    return savedData;
  },

  showChildCollection(region, coll) {
    if(this.model.get('isAdminEdit')) {
      this.showChildView(
        region,
        new OrderDeviceAdminCollectionView({
          collection: coll,
          contract: this.model.get('contract')
        })
      );
    } else {
      this.showChildView(
        region,
        new OrderDeviceCollectionView({
          collection: coll,
          contract: this.model.get('contract')
        })
      );
    }
  },

  populateCollection(collection, items) {
    _.each(items, (item) => {
      const dev = new Backbone.Model(item);
      collection.add(dev);
      this.collection.add(dev);
    });
    return collection;
  }
});

export default PRTNRDeviceSectionView;
